// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"6e7be8f5","305":"15cd0baa"}[chunkId] + ".chunk.js";
};